












































import { Component, Mixins, Prop, Vue, Ref } from 'vue-property-decorator'
import EditDialogMixin from '@/common/dialogs/mixins/edit-dialog-mixin'
import Judge from '@/evaluations/entities/judge'

@Component
export default class JudgeDialog extends Mixins<EditDialogMixin<Judge>>(
  EditDialogMixin
) {
  model = new Judge()
}
